// Responsive srcset builder: product image_sizes entries are {width: url} maps
// produced by the media pipeline (WebP/AVIF derivatives at 320..2000). Mobile
// must never fetch a desktop-sized asset.
export function srcsetFor(sizeMap) {
  if (!sizeMap || typeof sizeMap !== "object") return undefined;
  const parts = Object.entries(sizeMap)
    .filter(([w, u]) => u && /^\d+$/.test(w))
    .sort((a, b) => Number(a[0]) - Number(b[0]))
    .map(([w, u]) => `${u} ${w}w`);
  return parts.length ? parts.join(", ") : undefined;
}
